import React from 'react';

function EPReports() {
  return (
    <div>EPReports</div>
  );
}

export default EPReports;
